import { render } from "./done-icon.vue?vue&type=template&id=3a7872c8"
import script from "./done-icon.vue?vue&type=script&lang=js"
export * from "./done-icon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__